import { ShippingNoticeLineItem } from 'support/types';

import { LineItemEntry } from '../types';

/**
 * Local, case-insensitive substring match of a line item against a search query.
 * Matches the product name and the raw identifier values (GTIN, sender/receiver
 * internal article numbers) — not the translated identifier labels. An empty or
 * whitespace-only query matches everything.
 */
export const matchesLineItemSearch = (entry: LineItemEntry, query: string): boolean => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return true;
  }
  const item = (entry.row as ShippingNoticeLineItem | undefined)?.item;
  const haystack: Array<string | undefined> = [
    item?.name,
    item?.identifiers?.gtin,
    item?.identifiers?.sender_internal,
    item?.identifiers?.receiver_internal,
  ];
  return haystack.some((value) => value?.toLowerCase().includes(normalized) ?? false);
};
